import { Container, Dialog, IconButton } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { ACTIONS, PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { Action } from '../../../../models/Action'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'
import { ActionPaper } from '../../../Core/Frames/ActionPaper'
import { MotorcycleBlockView } from '../../../Motorcycle/MotorcycleBlockView'
import CloseIcon from '@material-ui/icons/Close'
import { MotorcyclesDetailsForm } from './MotorcycleDetailsForm'
import { statesWithoutLojackDiscount } from '../../../../Constants'
import { BlueGrayBox } from '../../../Core/BlueGrayBox'
import { ReactComponent as AddSvg } from '../../../../assets/add_reverse.svg'
import policyModificationApi from '../../../../api/policyModification.api'
import { awaitWithLoading } from '../../../../services/utils'
import { CustomErrorPopup } from '../../../PopUps/CustomErrorPopup'

export const MotorcyclesDetailsModification = ({ onContinue, tabIndex }) => {
  let modifyContext = useContext(PolicyModificationContextStore)
  const [motorEditState, setMotorState] = useState({ motor: {}, open: false, index: '' })
  const [isLojackFactordDisabled, setIsLojackFactordDisabled] = useState(false)
  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
  })
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '' })

  const saveMotorcycleDetails = async (data, index) => {
    const motorcycles = [...modifyContext.motorcycles_details]
    if (index === undefined) {
      const vehicleCoverages = await awaitWithLoading(policyModificationApi.getNewVehicleBasicCoverages(modifyContext.insuranceId))
      data.vehicle_coverages = vehicleCoverages.data.vehicles_coverages
      data.is_diminishing_deductible = false
      data.isNewVehicle = true
      data.id = crypto.randomUUID()
      modifyContext.rider_details.forEach(rider => rider.vehicle_ids.push(data.id))
      motorcycles.push(data)
      modifyContext.dispatch(new Action(ACTIONS.SET_VEHICLE_MAX_ID, data.id))
    } else {
      motorcycles[index] = data
    }

    modifyContext.dispatch(new Action(ACTIONS.EDIT_MOTORCYCLES, motorcycles))
    setMotorState({ open: false, motor: {}, index: '' })
  }

  const handleContinue = () => {
    modifyContext.dispatch(new Action(ACTIONS.SAVE_MOTORCYCLES_DETAILS))
    onContinue(tabIndex)
  }
  const onDeleteExistingVehicle = async index => {
    if (modifyContext.motorcycles_details.length === 1) {
      setPopUpErrorState({
        title: 'Error',
        body: 'Prior to removing the sole listed vehicle, please ensure that you add a new vehicle.',
        showPopUp: true,
      })
    } else {
      const motorcycleId = modifyContext.motorcycles_details[index].id
      modifyContext.motorcycles_details.splice(index, 1)
      modifyContext.rider_details.forEach(rider => (rider.vehicle_ids = rider.vehicle_ids.filter(id => id != motorcycleId)))
      modifyContext.dispatch(new Action(ACTIONS.EDIT_MOTORCYCLES, modifyContext.motorcycles_details))
      modifyContext.dispatch(new Action(ACTIONS.EDIT_RIDERS, modifyContext.rider_details))
    }
  }

  const addMotor = () => {
    setMotorState({
      motor: {
        has_lienholder: false,
        zip_code: modifyContext.owner_details.zip_code,
        state: modifyContext.owner_details.state,
        progressive_symbol: 'default',
        symbol: -1,
        isNewVehicle: true,
      },
      open: true,
    })
  }

  useEffect(() => {
    setIsLojackFactordDisabled(statesWithoutLojackDiscount.includes(modifyContext.owner_details.state))
  }, [])

  return (
    <React.Fragment>
      <Container className='"margin-top-medium'>
        {modifyContext.motorcycles_details.map((motorcycle, index) => (
          <div key={index}>
            <ActionPaper
              onView={() => setMotorState({ open: true, motor: motorcycle, index: index })}
              deletable={!modifyContext.isRenewal && modifyContext.motorcycles_details.length > 0}
              onDelete={() => onDeleteExistingVehicle(index)}
            >
              <MotorcycleBlockView motorcycle={motorcycle} />
            </ActionPaper>
            <br />
          </div>
        ))}

        {!modifyContext.isRenewal && (
          <BlueGrayBox className="fit-content margin-bottom-basic" onClick={addMotor}>
            <FlexView vAlignContent={'center'} className="clickable fit-content">
              <AddSvg />
              <div className="text-body blue margin-left-6">
                Add {modifyContext.motorcycles_details.length == 0 ? 'a' : 'another'} motorcycle to your insurance
              </div>
            </FlexView>
          </BlueGrayBox>
        )}

        <FlexView vAlignContent="center" hAlignContent="left">
          <ContinueButton label="Continue" onClick={handleContinue} disabled={modifyContext.motorcycles_details.length == 0} />
        </FlexView>

        <Dialog fullScreen fullWidth open={motorEditState.open}>
          <Container>
            <FlexView className="full-width" hAlignContent={'right'}>
              <IconButton onClick={() => setMotorState({ motor: {}, open: false })}>
                <CloseIcon />
              </IconButton>
            </FlexView>
            <br />
            <MotorcyclesDetailsForm
              defaultValues={motorEditState.motor}
              isLojackFactordDisabled={isLojackFactordDisabled}
              onSave={saveMotorcycleDetails}
              index={motorEditState.index}
              needDisabled={!motorEditState.motor.isNewVehicle}
            />
          </Container>
        </Dialog>
      </Container>
      <CustomErrorPopup
        title={popUpErrorState.title}
        body={popUpErrorState.body}
        open={popUpErrorState.showPopUp}
        onCancel={cancelErrorPopup}
      />
    </React.Fragment>
  )
}
